<template>
  <div class="video-modal-overlay" :class="{ active: state.videoModalOpen }" @click="handleOverlayClick">
    <div class="video-modal__content" @click.stop>
      <button @click="closeVideoModal" class="video-modal__close">&times;</button>
      <div v-if="!videoLoaded" class="video-modal__loading">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <span>视频加载中</span>
      </div>
      <video
        ref="modalVideoRef"
        :src="state.videoModalUrl"
        class="video-modal__player"
        :class="{ 'video-modal__player--hidden': !videoLoaded }"
        controls
        autoplay
        @loadedmetadata="videoLoaded = true"
      ></video>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useAppStore } from '../composables/useAppStore'

const { state, closeVideoModal } = useAppStore()
const modalVideoRef = ref<HTMLVideoElement | null>(null)
const videoLoaded = ref(false)

function handleOverlayClick() {
  closeVideoModal()
}

watch(() => state.videoModalOpen, (val) => {
  if (val) {
    videoLoaded.value = false
  } else if (modalVideoRef.value) {
    modalVideoRef.value.pause()
    modalVideoRef.value.src = ''
  }
})

watch(() => state.videoModalUrl, () => {
  videoLoaded.value = false
})
</script>

<style scoped>
.video-modal__content {
  position: relative;
  max-width: 56rem;
  width: 100%;
  margin: 0 16px;
  border-radius: 16px;
  background: #f3f4f6;
  overflow: hidden;
}

.video-modal__loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 280px;
  background: #f3f4f6;
  border-radius: 16px;
  color: #9ca3af;
  font-size: 14px;
}

.video-modal__loading i {
  font-size: 24px;
}

.video-modal__close {
  position: absolute;
  top: -48px;
  right: 0;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.875rem;
  cursor: pointer;
  transition: color 0.2s;
}
.video-modal__close:hover {
  color: white;
}

.video-modal__player {
  display: block;
  width: 100%;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.video-modal__player--hidden {
  position: absolute;
  inset: 0;
  opacity: 0;
  pointer-events: none;
}
</style>
